export class AppConsts {
  static readonly tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';
  static remoteServiceBaseUrl: string;
  static remoteServiceBaseUrlFormat: string;
  static appBaseUrl: string;
  static appBaseHref: string;
  static appBaseUrlFormat: string;
  static recaptchaSiteKey: string;
  static appActiveDirectoryEnabled = false;
  static appLdapEnabled = false;
  static googleAnalytics: string;
  static googleTagManager: string;

  static localeMappings: any = [];

  static readonly userManagement = {
    defaultAdminUserName: 'admin',
  };

  static readonly localization = {
    defaultLocalizationSourceName: 'OCCManager',
    defaultLocalizationSourceNameEaf: 'Eaf',
  };

  static readonly authorization = {
    encrptedAuthTokenName: 'enc_auth_token',
  };

  static readonly grid = {
    defaultPageSize: 30,
  };

  static readonly themeUser = {
    themeName: 'themeUser',
    typeTheme: 'TypeTheme',
  };

  static readonly expirationToken = {
    keyName: 'timeExpirationToken',
    typeTheme: 'int',
  };

  static readonly LocaleCurrency = [
    {
      currencyCode: 'BRL',
      initials: 'BRA',
      locale: 'pt-BR',
    },
    {
      currencyCode: 'USD',
      initials: 'USA',
      locale: 'en',
    },
    {
      currencyCode: 'ARS',
      initials: 'ARG',
      locale: 'es-AR',
    },
    {
      currencyCode: 'CLP',
      initials: 'CHI',
      locale: 'es-CL',
    },
    {
      currencyCode: 'BOB',
      initials: 'BOL',
      locale: 'es-BO',
    },
    {
      currencyCode: 'DOP',
      initials: 'DOM',
      locale: 'es-DO',
    },
    {
      currencyCode: 'USD',
      initials: 'PER',
      locale: 'es-PE',
    },
    {
      currencyCode: 'PYG',
      initials: 'PAR',
      locale: 'es-PY',
    },
    {
      currencyCode: 'USD',
      initials: 'ECU',
      locale: 'es-EC',
    },
    {
      currencyCode: 'USD',
      initials: 'URU',
      locale: 'es-UY',
    },
  ];

  static readonly flightLaunchTypeRoute = [
    { value: 1, displayValue: 'Arrival' },
    { value: 2, displayValue: 'Departure' },
  ];

  static readonly notamTypeRoute = [
    { value: 0, displayValue: 'Nenhum' },
    { value: 1, displayValue: 'Notam' },
    { value: 2, displayValue: 'SuplNotam' },
    { value: 3, displayValue: 'Briefing' },
    { value: 4, displayValue: 'Extra Fuel' },
    { value: 5, displayValue: 'NOTAM GPS' },
    { value: 6, displayValue: 'Equipamento' },
  ];

  static readonly occurrenceTypes = [
    {
      key: 'operations',
      value: 0,
      name: 'Operações',
      types: [
        {
          key: 'alternating',
          value: 0,
          name: 'Alternados',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'alternating', 'motive', 'fRem', 'remarks'],
        },
        {
          key: 'operationsDelay',
          value: 1,
          name: 'Atrasos',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'code', 'employee', 'remarks'],
        },
        {
          key: 'overloadAndLoads',
          value: 2,
          name: 'Overload & cargas',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'remarks'],
        },
        {
          key: 'cPTFuel',
          value: 3,
          name: 'CPT fuel',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'commander', 'remarks'],
        },
        {
          key: 'maintenance',
          value: 4,
          name: 'Manutenção',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'remarks'],
        },
        {
          key: 'pCN',
          value: 5,
          name: 'PCN',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'remarks'],
        },
        {
          key: 'differentiatedSchedules',
          value: 6,
          name: 'Planejamentos diferenciados',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'remarks'],
        },
        {
          key: 'crewReport',
          value: 7,
          name: 'Crew report',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'commander', 'remarks'],
        },
        {
          key: 'engineeringAndStandards',
          value: 8,
          name: 'Engenharia & standards',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'remarks'],
        },
        {
          key: 'operationsOthers',
          value: 9,
          name: 'Outros',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'remarks'],
        },
      ],
    },
    {
      key: 'coordination',
      value: 1,
      name: 'Coordenação',
      types: [
        {
          key: 'studies',
          value: 10,
          name: 'Estudos',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'remarks'],
        },
        {
          key: 'constIndex',
          value: 11,
          name: 'Cost index',
          fields: ['flightNumber', 'flightOrigin', 'flightDestiny', 'remarks'],
        },
        {
          key: 'coordinationOthers',
          value: 12,
          name: 'Outros',
          fields: ['remarks'],
        },
      ],
    },
    {
      key: 'airports',
      value: 2,
      name: 'Aeroportos & FIR',
      types: [
        {
          key: 'strike',
          value: 13,
          name: 'Greve',
          fields: ['location', 'remarks'],
        },
        {
          key: 'notams',
          value: 14,
          name: `NOTAM's`,
          fields: ['location', 'remarks'],
        },
        {
          key: 'airTraffic',
          value: 15,
          name: 'Tráfego aéreo',
          fields: ['location', 'remarks'],
        },
        {
          key: 'meteorology',
          value: 16,
          name: 'Meteorologia',
          fields: ['location', 'remarks'],
        },
        {
          key: 'extraFuel',
          value: 25,
          name: 'Extra fuel',
          fields: ['location', 'remarks'],
        },
        {
          key: 'airportsOthers',
          value: 17,
          name: 'Outros',
          fields: ['location', 'remarks'],
        },
      ],
    },
    {
      key: 'management',
      value: 3,
      name: 'Gestão',
      types: [
        {
          key: 'absence',
          value: 18,
          name: 'Falta',
          fields: ['employee', 'remarks'],
        },
        {
          key: 'managementDelay',
          value: 19,
          name: 'Atraso',
          fields: ['employee', 'remarks'],
        },
        {
          key: 'dM',
          value: 20,
          name: 'DM',
          fields: ['employee', 'remarks'],
        },
        {
          key: 'feedback',
          value: 21,
          name: 'Feedback',
          fields: ['employee', 'remarks'],
        },
        {
          key: 'scale',
          value: 26,
          name: 'Escala',
          fields: ['employee', 'remarks'],
        },
        {
          key: 'managementOthers',
          value: 22,
          name: 'Outros',
          fields: ['employee', 'remarks'],
        },
      ],
    },
    {
      key: 'iT',
      value: 4,
      name: 'T.I.',
      types: [
        {
          key: 'systemCrashes',
          value: 23,
          name: 'Quedas de sistema',
          fields: ['remarks'],
        },
        {
          key: 'iTOthers',
          value: 24,
          name: 'Outros',
          fields: ['remarks'],
        },
      ],
    },
  ];

  static readonly newOccurrenceAreas = [
    { value: 0, displayValue: 'Operações' },
    { value: 1, displayValue: 'Coordenação' },
    { value: 2, displayValue: 'Aeroportos & FIR' },
    { value: 3, displayValue: 'Gestão' },
    { value: 4, displayValue: 'T.I.' },
  ];

  static readonly flightMonitoringArea = [
    { value: 0, displayValue: 'Alternado' },
    { value: 1, displayValue: 'Base QGO' },
    { value: 2, displayValue: 'Reclearance Doméstico' },
    { value: 3, displayValue: 'Reclearance Internacional' },
    { value: 4, displayValue: 'Voo VFR' },
    { value: 5, displayValue: 'Desvio em rota' },
    { value: 6, displayValue: 'Comunicação' },
    { value: 7, displayValue: 'ETOPS' },
    { value: 8, displayValue: 'Voo SCEL' },
    { value: 9, displayValue: 'Acars Inop' },
    { value: 10, displayValue: 'Debriefing' },
    { value: 12, displayValue: 'Alteração de plano de voo em rota' },
    { value: 11, displayValue: 'Outros' },
  ];

  static readonly flightMonitoringType = [
    { value: 0, displayValue: 'HF' },
    { value: 1, displayValue: 'HF-ACARS' },
    { value: 2, displayValue: 'ACARS' },
    { value: 3, displayValue: 'HF-Satcom' },
    { value: 4, displayValue: 'HF-Satcom-ACARS' },
  ];

  static readonly eventsBriefing = [
    { id: 0, name: 'Meteorologia', fields: ['iata', 'meteorology', 'highlight'] },
    { id: 1, name: 'Notam', fields: ['iata', 'description', 'highlight'] },
    { id: 2, name: 'Tráfego Aéreo', fields: ['iata', 'description', 'highlight'] },
    { id: 3, name: 'Operações', fields: ['iata', 'description', 'highlight'] },
  ];

  static readonly imagesBriefing = [
    { name: 'CLOUDY', img: 'cloudy.png', desc: 'nublado' },
    { name: 'HEAVY_RAIN', img: 'heavy_rain.png', desc: 'chuva forte' },
    { name: 'MEDIUM_RAIN', img: 'medium_rain.png', desc: 'chuva moderada' },
    { name: 'MISTY', img: 'misty.png', desc: 'céu encoberto' },
    { name: 'NIGHT', img: 'night.png', desc: 'noite' },
    { name: 'SOFT_RAIN', img: 'soft_rain.png', desc: 'chuva leve' },
    { name: 'STRONG_WIND', img: 'strong_wind.png', desc: 'ventos fortes' },
    { name: 'SUNNY', img: 'sunny.png', desc: 'ensolarado' },
    { name: 'LIGHTNING', img: 'lightning.jpeg', desc: 'relâmpago' },
  ];

  static readonly workScaleTypes = [
    { value: 0, displayValue: 'Troca de Escala' },
    { value: 1, displayValue: 'Pedido de Folga' },
    { value: 2, displayValue: 'Solicitação Empresa' },
    { value: 3, displayValue: 'Dispensa Médica' },
    { value: 4, displayValue: 'Outros' },
  ];

  static readonly rootTypes = [
    { value: 0, displayValue: 'Operacional' },
    { value: 1, displayValue: 'Administrativo' },
  ];

  static readonly themeTypes = [
    { value: 0, displayValue: 'Processos' },
    { value: 1, displayValue: 'Sistemas' },
  ];

  static readonly statusTypes = [
    { value: 0, displayValue: 'Enviar', color: '#f7b7c4' },
    { value: 1, displayValue: 'Em análise', color: '#f5eba9' },
    { value: 2, displayValue: 'Concluído', color: '#8cffa7' },
  ];

  static readonly shiftList = [
    { value: '1', displayValue: '1', start: '00h00', end: '06h00' },
    { value: '2', displayValue: '2', start: '06h00', end: '12h00' },
    { value: '3', displayValue: '3', start: '12h00', end: '18h00' },
    { value: '4', displayValue: '4', start: '18h00', end: '00h00' },
    { value: '5', displayValue: '5', start: '15h00', end: '21h00' },
    { value: '6', displayValue: '6', start: '05h00', end: '11h00' },
    { value: '7', displayValue: '7', start: '11h00', end: '17h00' },
    { value: '8', displayValue: '8', start: '17h00', end: '23h00' },
    { value: '9', displayValue: '9', start: '10h00', end: '16h00' },
    { value: '10', displayValue: '10', start: '08h00', end: '14h00' },
    { value: 'C2', displayValue: 'C2', start: '05h00', end: '11h00' },
    { value: 'C3', displayValue: 'C3', start: '11h00', end: '17h00' },
    { value: 'C4', displayValue: 'C4', start: '17h00', end: '23h00' },
    { value: 'F2', displayValue: 'F2', start: '06h00', end: '12h00' },
    { value: 'F14', displayValue: 'F14', start: '14h00', end: '20h00' },
    { value: 'G1', displayValue: 'G1', start: '00h00', end: '06h00' },
    { value: 'G2', displayValue: 'G2', start: '06h00', end: '12h00' },
    { value: 'G3', displayValue: 'G3', start: '12h00', end: '18h00' },
    { value: 'G4', displayValue: 'G4', start: '18h00', end: '00h00' },
    { value: 'G5', displayValue: 'G5', start: '15h00', end: '21h00' },
    { value: 'R1', displayValue: 'R1', start: '00h00', end: '12h00' },
    { value: 'R2', displayValue: 'R2', start: '05h00', end: '11h00' },
    { value: 'R3', displayValue: 'R3', start: '11h00', end: '17h00' },
    { value: 'R4', displayValue: 'R4', start: '17h00', end: '23h00' },
    { value: 'R5', displayValue: 'R5', start: '15h00', end: '21h00' },
    { value: 'R7', displayValue: 'R7', start: '07h00', end: '13h00' },
  ];

  static readonly workScaleStatus = [
    { value: 0, name: 'Pendente', color: '#f5eba9' },
    { value: 1, name: 'Aprovado', color: '#8cffa7' },
    { value: 2, name: 'Reprovado', color: '#f7b7c4' },
    { value: 3, name: 'Ciente', color: '#8cffa7' },
    { value: 4, name: 'Pendente ciência', color: '#f5eba9' },
  ];

  static readonly statusAlternate = [
    { value: 0, displayValue: 'Proibido', color: '#ff0000' },
    { value: 1, displayValue: '', color: '#008000' },
    { value: 2, displayValue: 'Suspensão da Política pela Supervisão DSP Lider', color: '#ff0000' },
    { value: 3, displayValue: 'Alternativa Proibida - Suspensão da Política pela Supervisão DSP Lider', color: '#ff0000' },
  ];

  static readonly typeAlternate = [
    { value: 0, displayValue: 'METAR' },
    { value: 1, displayValue: 'TAF' },
  ];

  static readonly typeFeedback = [
    { value: 0, displayValue: 'Aplicado' },
    { value: 1, displayValue: 'Não Aplicado' },
  ];
}
